import { IS_NEMAN, IS_PRODUCTION } from 'services/constants/env';
import { PATHS } from 'routes/constants';

const KEYCLOAK_URL_PROD = 'https://id.easproject.com/auth';
const KEYCLOAK_URL_DEV = 'https://id-dev.easproject.com/auth';

export const KEYCLOAK_URL: string =
	import.meta.env.VITE_KEYCLOAK_URL || (IS_PRODUCTION ? KEYCLOAK_URL_PROD : KEYCLOAK_URL_DEV);

export const KEYCLOAK_REALM: string = import.meta.env.VITE_KEYCLOAK_REALM || 'operator';

export const KEYCLOAK_CLIENT_ID: string = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'cc-spa';

export const KEYCLOAK_SCOPE: string = import.meta.env.VITE_KEYCLOAK_SCOPE ?? 'openid';

export const KEYCLOAK_ORIGIN: string = new URL(KEYCLOAK_URL).origin;

const OIDC_BASE = `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}/protocol/openid-connect`;

export const AUTHORIZE_ENDPOINT = `${OIDC_BASE}/auth`;

export const TOKEN_ENDPOINT = `${OIDC_BASE}/token`;

export const END_SESSION_ENDPOINT = `${OIDC_BASE}/logout`;

export const CHECK_SESSION_IFRAME_URL = `${OIDC_BASE}/login-status-iframe.html`;

export const REDIRECT_URI = `${window.location.origin}${PATHS.AUTH_CODE_PAGE}`;

export const SILENT_REDIRECT_URI = `${window.location.origin}/silent-check-sso.html`;

export const TOKEN_EXPIRY_SKEW_MS = 30_000;

export const MIN_REFRESH_DELAY_MS = 5_000;

export const SILENT_SSO_TIMEOUT_MS = 10_000;

export const SESSION_CHECK_INTERVAL_MS = 5_000;

export const PERSIST_REFRESH_TOKEN = IS_NEMAN;

export const USE_KEYCLOAK = !IS_NEMAN;
